import * as Yup from 'yup';

export const SignInSchema = Yup.object().shape({
  email: Yup.string().email().required('Email is required'),
  password: Yup.string().min(8).required('Please provide your password'),
});

export type SignInDataType = Yup.InferType<typeof SignInSchema>;

type InitialValues = {
  email: string;
  password: string;
};

export const signinInitialValues: InitialValues = {
  email: '',
  password: '',
};

export interface IUserData {
  companyId: string;
  createdAt: string;
  email: string;
  firstName: string;
  gender: string;
  id: string;
  lastName: string;
  phoneNumber: string;
  profilePicture: string;
  registrationNumber: string;
  isWithinFreeTrial: boolean;
  role: string;
  updatedAt: string;
  verificationStatus: string;
  isTestMode: boolean;
}

interface IToken {
  token: string,
  expiryTimeInMinutes: number;
}

export interface ISignInData {
  user: IUserData;
  accessToken: IToken;
  refreshToken: IToken;
}
